import { formatShortCash } from "@fartherfinance/frontend/formatting/numbers";

export const formatBalance = (bal: number): string => formatShortCash(bal, 2);
